import React from 'react';

import { SplitDescriptions } from '../../../components/SplitDescriptions';
import {
  AccessPointDetailsFragment,
  AccessPointType_enum,
  usegetAccessPointDetailsQuery,
} from '../../../graphql/hasura/generated';
import createDetailsLayout from '../../../layouts/createDetailsLayout';
import { getPropertyFeatureFlags } from '../../../utils';
import { createdAtAndByColumn, createHistoryOfChangesColumn } from '../../common/columns';
import { AccessPointDataChangeLogsByPkTable } from '../../DataChangeLog/tables';
import * as columns from '../columns';
import { AccessPointTypeDetails } from '../components/AccessPointTypeDetails';

const PropertyDetailsLayout = createDetailsLayout<AccessPointDetailsFragment>();

export const AccessPointDetailsPage: React.FC<any> = () => {
  return (
    <PropertyDetailsLayout
      modelName='AccessPoint'
      useQuery={(accessPointId) => {
        return usegetAccessPointDetailsQuery({
          variables: { accessPointId },
        });
      }}
      body={(accessPoint) => {
        const featureFlags = getPropertyFeatureFlags(accessPoint.property);

        const historyOfChangesColumn = createHistoryOfChangesColumn({
          tabTables: [{
            tableConfig: AccessPointDataChangeLogsByPkTable,
            tableArgs: accessPoint.accessPointId,
          }],
        });

        return (
          <>
            <SplitDescriptions
              row={accessPoint}
              leftSideColumns={[
                columns.propertyColumn,
                columns.nameColumn,
                columns.imageColumn,
                {
                  title: columns.typeColumn.title,
                  render: () => <AccessPointTypeDetails accessPoint={accessPoint} />
                },
                accessPoint.type === AccessPointType_enum.RESERVATION_ONLY ? columns.maxOccupancyColumn : null,
                accessPoint.archivedAt ? columns.archivedByUserColumn : null,
                createdAtAndByColumn,
                historyOfChangesColumn as any,
              ]}
              rightSideColumns={[
                columns.accessTimeoutColumn,
                featureFlags.DPS ? columns.rexAccessTimeoutColumn : null,
                columns.scheduleColumn,
                columns.spaceshipModeEnabledDetailsColumn,
                columns.proximityRestrictionDetailsColumn,
                featureFlags.DPS ? columns.dpsAlertDelayColumn : null,
                featureFlags.DPS ? columns.dpsAlertIntervalColumn : null,
              ]}
            />
          </>
        );
      }}
    />
  );
};
